import { DashboardModule, Form } from '@domain-group/suit-theme'

import type { UseFormPayload } from '@domain-group/react-hooks'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { generateUrls } from '@hooks/useBrand'

import EntitySelector from '@components/EntitySelector'

interface PaginationRuleDetailsProps {
  paginationRuleFormPayload: UseFormPayload,
}

const PaginationRuleDetails = (props: PaginationRuleDetailsProps) => {
  const { paginationRuleFormPayload } = props

  const {
    entityState: {
      brand_id,
      default: isDefault,
      group_items_by,
      placement_direction,
      start_page,
      title,
    },
    errors,
    handlers,
    setEntityState,
  } = paginationRuleFormPayload

  const { editBrandUrl } = generateUrls({ id: brand_id })

  return (
    <DashboardModule title="Pagination Rule Details">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="* Title" errorMessage={errors.title}>
            <input type="text" name="title" value={title} {...handlers} />
          </Form.Field>

          <EntitySelector
            callbacks={{
              selectItem: brand => setEntityState({ brand_id: brand ? brand.id : null }),
            }}
            entityKey="brands"
            errorMessage={errors.brand_id}
            goToHref={`${editBrandUrl}?redirect=${generateRedirectUrl()}`}
            label="* Brand"
            // @ts-expect-error TS2322
            marginTop={['large', 0]}
            selectedItemId={brand_id}
          />
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="* Default">
            {/*
             // @ts-expect-error TS2322 */}
            <select
              data-value-type="boolean"
              name="default"
              value={isDefault}
              {...handlers}
            >
              <option value="true">True</option>
              <option value="false">False</option>
            </select>
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="Group Items By" marginTop={['large', 0]}>
            {/*
             // @ts-expect-error TS2322 */}
            <select name="group_items_by" value={group_items_by} {...handlers}>
              <option value="">Default</option>
              <option value="campaign.state_name">Campaign State Name</option>
              <option value="order_item.group_key">Order Item Group Key</option>
            </select>
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="Placement Direction">
            {/*
             // @ts-expect-error TS2322 */}
            <select
              name="placement_direction"
              value={placement_direction}
              {...handlers}
            >
              <option value="">Default</option>
              <option value="RTL">Right to Left</option>
              <option value="LTR">Left to Right</option>
            </select>
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="Start Page" marginTop={['large', 0]}>
            {/*
             // @ts-expect-error TS2322 */}
            <select
              name="start_page"
              value={start_page}
              {...handlers}
            >
              <option value="">Default</option>
              <option value="LHS">LHS</option>
              <option value="RHS">RHS</option>
            </select>
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default PaginationRuleDetails
